import React, { createContext, useState } from "react";

export const DataContext = createContext();

export const DataProvider = ({ children }) => {
  const [activarForm, setActivarForm] = useState(false);

  return (
    <DataContext.Provider value={{ activarForm, setActivarForm }}>
      {children}
    </DataContext.Provider>
  );
};
